import { IconButton } from '@chakra-ui/react'
import {
  MenuContent,
  MenuItem,
  MenuItemGroup,
  MenuRoot,
  MenuSeparator,
  MenuTrigger,
} from './chakraComponents/menu'
import { useAuth0 } from '@auth0/auth0-react'
import { ColorModeButton, useColorMode } from './chakraComponents/color-mode'
import { Avatar } from './chakraComponents/avatar'
import { useEnvConfig } from 'rwo-react'

export const AccountPopover = () => {
  const { user, logout } = useAuth0()
  const { toggleColorMode } = useColorMode()
  const { clientId, redirectUri } = useEnvConfig();

  const logoutOptions = {
    logoutParams: {
      clientId: clientId,
      federated: true,
      returnTo: redirectUri
    }
  }
  const handleLogout = () => { logout(logoutOptions) };

  return (
    <MenuRoot closeOnSelect={false}>
      <MenuTrigger asChild>
        <IconButton variant={'plain'}>
          <Avatar
            size={'md'}
            name={`${user?.given_name} ${user?.family_name}`}
          />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        <MenuItemGroup title={user?.email}>
          <MenuItem
            _hover={{ cursor: 'pointer' }}
            onClick={handleLogout}
            value='logout'>
            Logout
          </MenuItem>
        </MenuItemGroup>
        <MenuSeparator />
        <MenuItemGroup title='Settings'>
          <MenuItem
            _hover={{ cursor: 'pointer' }}
            value='color-mode'
            onClick={toggleColorMode}
            justifyContent={'space-between'}>
            Color Mode
            <ColorModeButton />
          </MenuItem>
        </MenuItemGroup>
      </MenuContent>
    </MenuRoot>
  )
}
